import React, { Component } from "react";
import PropTypes from "prop-types";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";

class SSN extends Component {
  constructor(props) {
    super(props);

    this.state = {
      msgData: {
        errors: { ssn: {} },
        info: { ssn: {} },
      },
      ssn: {
        showMask: true,
        showHideBtnText: "Show",
        formattedMask: "",
        formattedText: "",
        value: "",
      },
      specialBrowser: false,
    };
    this.ssnValue = "";
    this.ssnMaxLength = 11;
    this.ssnMaxNoDash = 9;
  }

  static defaultProps = {
    element: {
      name: "ssn",
      prefix: "pf-contact-",
      id: "pf-contact-ssn",
      label: "Social Security",
      label2: "Number",
      placeHolder: "###-##-####",
      colLabelClassName: "label",
      colFieldClassName: "field",
      colShowHide: "showhide",
      colValidationClassName: "messaging",
    },
    colLayout: {
      1: { sm: 12, lg: 3 },
      2: { sm: 12, lg: 2 },
      3: { sm: 12, lg: 1 },
      4: { sm: 12, lg: 6 },
    },
  };

  static getDerivedStateFromProps(props, state) {
    if (props.userAgent) {
      const isAndroidV4x = props.userAgent.indexOf("Android 4") !== -1,
        isAmazonFire7 =
          props.userAgent.indexOf("Android 5") !== -1 &&
          props.userAgent.indexOf("KFAUWI") !== -1,
        isSMGalaxyS6 =
          props.userAgent.indexOf("Android 5.0.2; SM-G920F Build/LRX22G") !==
          -1,
        isSMGalaxy7 =
          props.userAgent.indexOf("Android 6.0.1; SM-G930F Build/MMB29K") !==
          -1,
        isSMGalaxyS8 =
          props.userAgent.indexOf("Android 7.0; SM-G950F Build/NRD90M") !== -1,
        isSMGalaxyS8Plus =
          props.userAgent.indexOf("Android 7.0; SM-G955F Build/NRD90M") !== -1,
        isIOS7 = props.userAgent.indexOf("iPhone; CPU iPhone OS 7") !== -1,
        isIOS8 = props.userAgent.indexOf("iPhone; CPU iPhone OS 8") !== -1,
        isIOS9 = props.userAgent.indexOf("iPhone; CPU iPhone OS 9") !== -1;

      if (
        isAndroidV4x ||
        isAmazonFire7 ||
        isSMGalaxyS6 ||
        isSMGalaxy7 ||
        isSMGalaxyS8 ||
        isSMGalaxyS8Plus ||
        isIOS7 ||
        isIOS8 ||
        isIOS9
      ) {
        return { specialBrowser: true };
      }
    }

    return null;
  }

  initMsgObj = () => {
    const { element } = this.props,
      msgData = {
        errors: {},
        info: {},
      };

    msgData.errors[element.name] = {};
    msgData.info[element.name] = {};

    return msgData;
  };

  generateMessage = (msgType) => {
    const { element, fieldMetadata } = this.props,
      notation = msgType === "error" ? "errors" : "info",
      msgData = this.initMsgObj();

    let msg = "";

    if (msgType === "info") {
      msg =
        "Why do we need this? Your Social Security number is used to obtain consumer reports to make credit decisions.";
      fieldMetadata.status = "";
    } else if (msgType === "error") {
      msg = "Please enter a valid Social Security number.";
      fieldMetadata.status = "invalid";
    }

    msgData[notation][element.name] = {
      type: msgType,
      msg: msg,
      id: element.id,
      slug: element.name,
    };

    return msgData;
  };

  formatWithDash = (value, index) => {
    const s1 = value.substring(0, index),
      s2 = value.substring(index);

    return s1.concat("-").concat(s2);
  };

  formatSSN = (value) => {
    const numOfChars = value.length;
    let val = value;

    if (numOfChars > 3 && numOfChars < 6) {
      if (val[3] !== "-") {
        val = this.formatWithDash(val, 3);
      }
    } else if (numOfChars >= 6) {
      if (val[3] !== "-") {
        val = this.formatWithDash(val, 3);
      }

      if (val[6] && val[6] !== "-") {
        val = this.formatWithDash(val, 6);
      }
    }

    return val;
  };

  maskIt = (value) => {
    const maskRegex = /\d/g;
    const mask = value.replace(maskRegex, "#");
    return mask;
  };

  validSSN = (value) => {
    const numRegex = /^[0-9]+$/;
    return value.match(numRegex);
  };

  getPosition = (position) => {
    let pos = position;

    if (position > 3 && position <= 6) {
      pos = pos - 1; // handles 1 hyphen
    } else if (position > 6) {
      pos = pos - 2; // handles 2 hyphens
    }
    return pos;
  };

  addNumber = (position, key) => {
    const ssnValueLength = this.ssnValue.length;
    let pos = this.getPosition(position);

    if (pos >= ssnValueLength) {
      this.ssnValue = this.ssnValue.concat(key);
    } else if (pos < ssnValueLength) {
      this.ssnValue =
        this.ssnValue.substring(0, pos) + key + this.ssnValue.substring(pos);
    }
  };

  deleteNumber = (position) => {
    let pos = this.getPosition(position);

    if (this.ssnValue && this.ssnValue[pos - 1]) {
      if (pos >= this.ssnValue.length) {
        // delete at end
        this.ssnValue = this.ssnValue.substring(0, pos - 1);
      } else {
        this.ssnValue =
          this.ssnValue.substring(0, pos - 1) + this.ssnValue.substring(pos);
      }
    }
  };

  validKey = (ev) => {
    const ZERO = "0",
      NINE = "9",
      ARROWLEFT = "ArrowLeft",
      ARROWRIGHT = "ArrowRight",
      DELETE = "Delete",
      BACKSPACE = "Backspace",
      TAB = "Tab",
      Fourth = 4,
      Seventh = 7;

    let position = ev.target.selectionStart,
      key = ev.key;

    if (key && key === "Unidentified") {
      if (ev.which === "229" && ev.keyCode === "229") return;
      key = String.fromCharCode(ev.which ? ev.which : ev.keyCode);
    }

    if (
      !(
        (key >= ZERO && key <= NINE) ||
        key === ARROWLEFT ||
        key === ARROWRIGHT ||
        key === DELETE ||
        key === BACKSPACE ||
        key === TAB
      )
    ) {
      ev.preventDefault();
    } else if (key >= ZERO && key <= NINE) {
      if (this.ssnValue.length < this.ssnMaxNoDash) {
        this.addNumber(position, key);
      }
    } else if (key === DELETE || key === BACKSPACE) {
      if (position > 0 && position !== Fourth && position !== Seventh) {
        this.deleteNumber(position);
      }
    }
  };

  toggleMaskButton = (ev) => {
    const { ssn } = this.state;

    ssn.showHideBtnText = ssn.showHideBtnText === "Show" ? "Hide" : "Show";
    ssn.showMask = !ssn.showMask;
    this.setState({ ssn });
  };

  handleChange = (ev) => {
    const ssnObj = this.state.ssn,
      { specialBrowser } = this.state,
      { fieldMetadata } = this.props,
      { value } = ev.target,
      elem = ev.target,
      Fourth = 4,
      Seventh = 7;

    let position = ev.target.selectionStart,
      prevFormattedValue = ssnObj.showMask
        ? ssnObj.formattedMask
        : ssnObj.formattedText;

    fieldMetadata.value = value;
    if (value && value.length > 0) {
      if (this.ssnValue && !specialBrowser) {
        ssnObj.value = this.ssnValue;
        ssnObj.formattedText = this.formatSSN(ssnObj.value);
        ssnObj.formattedMask = this.maskIt(ssnObj.formattedText);

        if (value.length > prevFormattedValue.length) {
          if (position === Fourth || position === Seventh) {
            position += 1;
          }
        }
      } else {
        ssnObj.value = value;
        ssnObj.formattedText = value;
      }
    } else {
      ssnObj.value = "";
      ssnObj.formattedMask = "";
      ssnObj.formattedText = "";
      position = 0;
      this.ssnValue = "";
    }

    this.setState(
      {
        ssn: ssnObj,
      },
      () => {
        window.requestAnimationFrame(() => {
          elem.selectionStart = position;
          elem.selectionEnd = position;
          // elem.setSelectionRange(position, position); - another way to do it
        });
      },
    );
  };

  handleBlur = (ev) => {
    const { onEventCallback, fieldMetadata } = this.props,
      { ssn, specialBrowser } = this.state;

    let msgData = this.initMsgObj();

    fieldMetadata.value = ssn.value;
    if (
      ssn.value.length < this.ssnMaxNoDash ||
      (specialBrowser && !this.validSSN(ssn.value))
    ) {
      msgData = this.generateMessage("error");
      fieldMetadata.status = "invalid";
      fieldMetadata.isValid = false;
    } else {
      fieldMetadata.status = "";
      fieldMetadata.isValid = true;

      if (specialBrowser) {
        ssn.showMask = true;
        ssn.formattedMask = this.maskIt(ssn.value);
      }
    }

    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, fieldMetadata);
    }

    this.setState({
      msgData,
      ssn,
    });
  };

  handleFocus = (ev) => {
    const { fieldMetadata } = this.props,
      { ssn, specialBrowser } = this.state;

    if (specialBrowser) {
      ssn.showMask = false;
      ssn.formattedText = ssn.value;
    }

    fieldMetadata.status = "";
    this.setState({
      msgData: this.generateMessage("info"),
      ssn,
    });
  };

  handleTimeout = (ev) => {
    setTimeout(this.handleChange(ev), 200);
  };

  render() {
    const { element, colLayout, fieldMetadata } = this.props;
    let { msgData, ssn, specialBrowser } = this.state;

    if (fieldMetadata.status === "invalid") {
      msgData = this.generateMessage("error");
    } else if (
      fieldMetadata.value &&
      fieldMetadata.value.length === this.ssnMaxNoDash &&
      !ssn.value
    ) {
      this.ssnValue = fieldMetadata.value;
      ssn.value = fieldMetadata.value;
      ssn.formattedText = this.formatSSN(ssn.value);
      if (ssn.showMask) {
        ssn.formattedMask = this.maskIt(ssn.formattedText);
      }
    }

    return (
      <Row className={element.prefix + element.name}>
        <Col className={element.colLabelClassName} width={colLayout[1]}>
          <label className="label-split" htmlFor={element.id}>
            <span className="text">{element.label}</span>
            <span className="text">{element.label2}</span>
          </label>
        </Col>
        <Col className={element.colFieldClassName} width={colLayout[2]}>
          <input
            id={element.id}
            className={fieldMetadata.status}
            type="tel"
            name={element.name}
            value={ssn.showMask ? ssn.formattedMask : ssn.formattedText}
            maxLength={specialBrowser ? this.ssnMaxNoDash : this.ssnMaxLength}
            placeholder={element.placeHolder}
            onChange={this.handleTimeout}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onKeyDown={this.validKey}
            autoComplete={fieldMetadata.autocomplete || null}
          />
        </Col>
        {!specialBrowser && (
          <Col className={element.colShowHide} width={colLayout[3]}>
            <button type="button" onClick={this.toggleMaskButton}>
              {ssn.showHideBtnText}
            </button>
          </Col>
        )}
        <Col className={element.colValidationClassName} width={colLayout[4]}>
          <ValidationMsg
            who={element.name}
            filterFields={[element.name]}
            msgs={msgData}
          />
        </Col>
      </Row>
    );
  }
}

SSN.propTypes = {
  colLayout: PropTypes.object.isRequired,
  element: PropTypes.object.isRequired,
  onEventCallback: PropTypes.func,
  fieldMetadata: PropTypes.object.isRequired,
  userAgent: PropTypes.string.isRequired,
};

export default SSN;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');